<div class="visual-link-container">
  <div class="visual-link-inner-container">
    <img [src]="imageUrl" />
    <a [href]="linkUrl" target="_blank">{{ linkText  | uppercase }}</a>
  </div>
</div>
